/**
 * /comms/channels/$accountId — critical route shell for the account detail.
 * Component code-split into ./channels.$accountId.lazy. Agent U2.
 */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/comms/channels/$accountId')({});
